import ModalContext from '@Context/modalContext';
import { Button, Modal } from '@kg-internal/pv3-uikit';
import { ReactNode, useContext, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';

type Props = {
  title: string;
  children: ReactNode;
  show: boolean;
  primaryAction?: () => void;
  primaryButtonText?: string;
  handleClose: () => void;
  disablePrimary?: boolean;
  hideBottomElement?: boolean;
};

type BottomProps = {
  disabled?: boolean;
  primaryAction?: () => void;
  primaryButtonText?: string;
  secondaryAction?: () => void;
};

const BottomElement = ({ disabled = false, primaryAction, primaryButtonText, secondaryAction }: BottomProps) => (
  <div className='content-middle content-right-md'>
    <Button type='secondary' onClick={secondaryAction}>
      Cancel
    </Button>
    <Button type='primary' onClick={primaryAction} disabled={disabled}>
      {primaryButtonText || 'Submit'}
    </Button>
  </div>
);

const ModalWrapper = ({
  title,
  show,
  handleClose,
  primaryAction,
  disablePrimary = false,
  children,
  primaryButtonText,
  hideBottomElement,
}: Props) => {
  const { isModalOpen, setIsModalOpen } = useContext(ModalContext);

  useEffect(() => {
    setIsModalOpen(show);
  }, [show]);

  return (
    <Modal
      title={title}
      clickOutside
      show={show}
      showClose
      onClose={handleClose}
      customBottomElement={
        !hideBottomElement && (
          <BottomElement
            primaryAction={primaryAction}
            primaryButtonText={primaryButtonText}
            secondaryAction={handleClose}
            disabled={disablePrimary}
          />
        )
      }>
      {isModalOpen && <Toaster position='top-right' />}
      {children}
    </Modal>
  );
};
export default ModalWrapper;
